import { useEffect, useState } from "react";
import { useFetcher, useNavigate } from "react-router-dom";
import { useGlobal } from "../../components/GlobalProviderLayout";
import { SET_EMAIL_SUBMITTED } from "../../components/GlobalProviderLayout/GlobalProviderLayoutModel";
import { packObjForSubmit, unpackObjForSubmit } from "../../utils";
import { doFetchPut } from "../../utils/doFetchPut";
import { ContactEmail } from "./ContactEmail";


export const contactEmailRouteAction = async ({ request }: { request: any, params: any }) => {
  let formData = await request.formData();
  let obj = JSON.parse(unpackObjForSubmit(formData));
  return await doFetchPut('my-profile-contact-email', { signal: request.signal }, obj)
}

export const ContactEmailRoute = () => {
  const fetcher = useFetcher();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const global = useGlobal();

  useEffect(() => {
    const res = fetcher.data;
    if (res?.success) navigate('/my-profile');
  }, [fetcher.data, navigate])

  const isValidEmail = (value: string) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(value);
  };

  const onChangeEmail = (email: string) => {
    setError(false);
    setEmail(email);
  }

  const onSubmit = async (email: string) => {
    if (!isValidEmail(email)) return setError(true);
    const formData = packObjForSubmit({ email });
    fetcher.submit(formData, { method: "put" });
    global.dispatch({ type: SET_EMAIL_SUBMITTED, payload: true });
  };

  return (
    <ContactEmail
      submitting={fetcher.state === "submitting"}
      email={email}
      error={error}
      onChangeEmail={onChangeEmail}
      onSubmit={onSubmit}
    />
  )
}